export default "__VITE_ASSET__DcyX5Oua__"